import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewUserPageNew from "../../components/User/ViewUserPageNew";



const ViewUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="User Management" link2="/user" title="View User" />

        {/* AddUserLayer */}
        <ViewUserPageNew roles="user" />


      </MasterLayout>
    </>
  );
};

export default ViewUserPage;
